import { render, staticRenderFns } from "./AgenteIAChat.vue?vue&type=template&id=662aa3a6&scoped=true"
import script from "./AgenteIAChat.vue?vue&type=script&lang=js"
export * from "./AgenteIAChat.vue?vue&type=script&lang=js"
import style0 from "./AgenteIAChat.vue?vue&type=style&index=0&id=662aa3a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662aa3a6",
  null
  
)

export default component.exports